<!-- 给排水 -->
<template>
  <div class="water-supply-right common-bg">
    <water-num :waterSupplyData="waterSupplyData"></water-num>
    <water-status :waterSupplyData="waterSupplyData"></water-status>
    <div class="psDom" :class="getBg">
      <div class="header-dialog">
        <div class="top-name" :class="getTopBg">
          <div class="name">给排水设备</div>
          <div @pointerdown="clickClose" class="imgbg"></div>
        </div>
      </div>
      <div class="bot-content">
        <div class="left-name">{{ nameMap[nameVal] }}</div>
        <div class="right-status" :class="getStatus">
          {{ statusMachine }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import waterNum from "./components/water-num.vue";
import WaterStatus from "./components/water-status.vue";
import bus from "@/components/three-scene/Bus.js";
import { getWaterSupply } from "@/api";
export default {
  components: { waterNum, WaterStatus },
  data() {
    return {
      nameVal: null,
      isdestroyed: false,
      waterSupplyData: {},
      nameMap: {
        SBF_泵1: "一号泵",
        SBF_泵2: "二号泵",
        SBF_泵3: "三号泵",
        SBF_泵4: "四号泵",
      },
      statusMap: {
        SBF_泵1: 0,
        SBF_泵2: 1,
        SBF_泵3: 2,
        SBF_泵4: 3,
      },
      pumpStatus: [],
      timer: null,
      waterLevel: {},
    };
  },
  computed: {
    statusMachine() {
      return this.pumpStatus?.[this.statusMap[this.nameVal]]?.status;
    },
    getStatus() {
      if (this.statusMachine) {
        if (this.statusMachine == "待机") {
          return "wait-bg";
        } else if (this.statusMachine == "告警") {
          return "warn-bg";
        } else {
          return "normal-bg";
        }
      } else {
        return "";
      }
    },
    getBg() {
      if (this.statusMachine) {
        if (this.statusMachine == "待机") {
          return "standby-infor";
        } else if (this.statusMachine == "告警") {
          return "warn-infor";
        } else {
          return "infor";
        }
      } else {
        return "";
      }
    },

    getTopBg() {
      if (this.statusMachine) {
        if (this.statusMachine == "待机") {
          return "top-color2";
        } else if (this.statusMachine == "告警") {
          return "top-color1";
        } else {
          return "top-color";
        }
      } else {
        return "";
      }
    },
  },
  mounted() {
    bus.emit("psToSprite");
    this.$store.state.threeEvent.intoWaterPump = true;
    bus.on("sbfClick", (name) => {
      this.nameVal = name;
    });
  },
  created() {
    bus.emit("changeScene", "SBF");

    this.getWaterSupplyData();
    this.timer = setInterval(() => {
      this.getWaterSupplyData();
    }, 30*60*1000);
  },

  methods: {
    clickClose() {
      bus.emit("close");
    },
    async getWaterSupplyData() {
      let { data: res } = await getWaterSupply();
      if (!res) return;
      if (this.isdestroyed) return;
      this.waterSupplyData = res;
      this.pumpStatus = [];
      for (let i = 1; i <= 4; ++i) {
        this.pumpStatus.push({
          name: `pump${i}Running`,
          status: res[`pump${i}Running`].value,
        });
      }
      if (
        res.level.value.match(/^\d+\.\d+/gi)[0] !==
        this.waterLevel?.level?.value?.match(/^\d+\.\d+/gi)[0]
      ) {
        bus.emit(
          "liquidLevel",
          res.levelUpperLimit,
          res.level.value.match(/^\d+\.\d+/gi)[0]
        );
        this.waterLevel = {
          levelUpperLimit: res.levelUpperLimit,
          level: res.level,
        };
      }
      bus.emit("changeFloorBqMap", this.pumpStatus);
    },
  },
  destroyed() {
    this.isdestroyed = true;
    bus.emit("removeSprite");
    bus.emit("psRemoveSprite");
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style lang="scss" scoped>
.water-supply-right {
  position: absolute;
  top: 135px;
  left: 107px;
  width: 416px;
}
.psDom {
  width: 300px;
  color: #fff;
  .normal-bg {
    background: rgba(45, 130, 255, 0.3);
    // border: 2px solid rgba(45, 130, 255, 0.2);
    box-shadow: 0px 0px 4px 2px rgba(45, 130, 255, 0.2),
      inset 0px 0px 8px 2px rgb(45, 130, 255);
  }

  .warn-bg {
    background: rgba(241, 128, 47, 0.5);
    // border: 1px solid #f1802f;
    box-shadow: 0px 0px 4px 2px rgba(241, 128, 47, 0.2),
      inset 0px 0px 4px 2px rgba(241, 128, 47, 0.92);
  }

  .wait-bg {
    background: rgba(255, 255, 255, 0.3);
    // border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0px 0px 4px 2px rgba(255, 255, 255, 0.2),
      inset 0px 0px 4px 2px rgba(255, 255, 255, 0.5);
  }
  .header-dialog {
    .top-color {
      background: rgba(45, 130, 255, 0.4);
    }
    .top-color1 {
      background: rgba(241, 128, 47, 0.4);
    }
    .top-color2 {
      background: rgba(175, 175, 175, 0.4);
    }
    .top-name {
      .name {
        font-style: normal;
      }
    }
  }
  .bot-content {
    width: 100%;
    // height: 75px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    color: #ffffff;
    .left-name {
      font-weight: 500;
      font-size: 20px;
      line-height: 30px;
    }
    .right-status {
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      width: 64px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 2px;
    }
  }
}
.infor {
  border-image: url("../../../../../../assets/cut/backimg-normal.png");
}
.warn-infor {
  border-image: url("../../../../../../assets/cut/test.png");
}
.standby-infor {
  border-image: url("../../../../../../assets/cut/stand.png");
}
.infor,
.standby-infor,
.warn-infor {
  border-image-slice: 55 166 75 65 fill;
  border-image-width: 20px 50px 20px 20px; // 设置各个区域的图片宽度
  border-image-repeat: repeat; // 图片重复或拉伸模式
  // border-image-outset: 10px 10px 10px 10px; //
}
</style>
